import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Button, Modal, Text, Box, Icon } from "@sproutsocial/racine";
import { capitalize } from "utils/js";
import { STATUSES } from "./constants";
import { themeGet } from "@styled-system/theme-get";
import { navigate } from "gatsby";
import { trackEvent } from "utils/js";

const CustomButton = styled(Button)`
  ${(p) => p.theme.typography[300]}
  border-radius: ${(p) => p.theme.radii.pill};
  padding: ${(p) => p.theme.space[200]} ${(p) => p.theme.space[350]};

  &:hover {
    color: ${(props) => themeGet("colors." + props.hoverColor)};
    background-color: ${(props) => themeGet("colors." + props.hoverBg)};
  }
`;

const StatusButton = ({ content, status, location, ...rest }) => {
  const { hash, pathname } = location;
  const showScorecard = hash === "#status" && !pathname.includes("sandbox");
  const [open, setOpen] = useState(showScorecard);

  const hideModal = () => {
    setOpen(!open);
    window.location.hash = "";
  };

  const onClick = () => {
    if (open) {
      window.history.back();
    } else {
      trackEvent("Open scorecard", { category: "scorecard", label: pathname });
      navigate("#status");
    }

    setOpen(!open);
  };

  const { color, bg, hoverColor, hoverBg, description } =
    STATUSES[status.toLowerCase()];
  const formattedStatus = capitalize(status);

  useEffect(() => {
    if (!showScorecard) {
      setOpen(false);
    }
  }, [showScorecard, setOpen]);

  return (
    <React.Fragment>
      <CustomButton
        color={color}
        bg={bg}
        hoverColor={hoverColor}
        hoverBg={hoverBg}
        fontSize={300}
        onClick={onClick}
        mr={400}
        aria-label={`Status: ${formattedStatus}`}
        {...rest}
      >
        <Icon
          name="heart-pulse-outline"
          mr={200}
          mt={-200}
          pl="1px"
          fixedWidth
        />{" "}
        {formattedStatus}
      </CustomButton>

      <Modal
        isOpen={open}
        onClose={hideModal}
        closeButtonLabel="Close scorecard"
        label="Scorecard"
        zIndex={500}
        width="22rem"
      >
        <Modal.Header
          flexWrap="wrap"
          bg={bg}
          borderTopLeftRadius="outer"
          borderTopRightRadius="outer"
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width={1}
          >
            <Text
              forwardedAs="h1"
              fontWeight="bold"
              color={color}
              fontSize={500}
              css={`
                display: inline-flex;
                align-items: center;
              `}
            >
              <Icon name="heart-pulse-outline" size="medium" mr={350} />{" "}
              {formattedStatus}
            </Text>

            <Modal.CloseButton />
          </Box>

          <Text as="div" color="text.body" fontSize={200} mt={300}>
            {description}
          </Text>
        </Modal.Header>

        <Modal.Content>
          <Text as="div" fontSize={200}>
            {content}
          </Text>
        </Modal.Content>
      </Modal>
    </React.Fragment>
  );
};

export default StatusButton;
